import React, { useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { CheckCircle } from "react-feather";
import { useLocation } from "react-router-dom";
import "./FromHome.css";
import ContactPageForm from "../ContactPage/ContactPageForm";

const FromHome = () => {
  const location = useLocation();
  const { targetHeading } = location.state || {};

  // Scroll to the target container when the component mounts
  useEffect(() => {
    const container = document.getElementById("stophere");
    if (container) {
      container.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [targetHeading]);

  if (!targetHeading) {
    return <p>Service details not found.</p>;
  }

  return (
    <div>
      <Container
        fluid
        className="fromhomeservices-container mb-5"
        id="stophere"
      >
        <Row className="text-center services-header">
          <p className="fromhomeservices-subtitle mt-5">Services Spectrum</p>
          <h2 className="fromhomeservices-title">{targetHeading.title}</h2>

          <div className="container mt-5" id={targetHeading.title}>
            <Row className="fromhomeservices-content">
              <Col
                lg={6}
                className="fromhomeservices-image-container"
                style={{ marginTop: "20px" }}
              >
                <img
                  src={targetHeading.imageUrl}
                  alt={targetHeading.title}
                  className="fromhomeservices-image"
                />
              </Col>
              <Col lg={6} className="fromhomeservices-text">
                <div className="fromhomeservices-list">
                  {/* Render the description as a list */}
                  {targetHeading.points &&
                    Array.isArray(targetHeading.points) && (
                      <ul>
                        {targetHeading.points.map((desc, i) => (
                          <li key={i}>{desc}</li>
                        ))}
                      </ul>
                    )}
                </div>
                {/* Add a Read More button */}
                <a href="/services">
                  <button
                    className="btn mb-5"
                    style={{ backgroundColor: "#5B3DAD", color: "white" }}
                  >
                    View More !
                  </button>
                </a>
              </Col>
            </Row>
          </div>
        </Row>
      </Container>

      <ContactPageForm />
    </div>
  );
};

export default FromHome;
